import { createContext } from 'react';
import { useFeatures } from 'hooks/useFeatures';

export const FeaturesContext = createContext<{
  isLoading: boolean;
  refetch: () => Promise<Record<string, any>>;
  features: Record<string, boolean> | undefined;
}>({
  isLoading: false,
  refetch: undefined,
  features: undefined,
});

export const FeaturesProvider = ({ children }) => {
  const { data: features, refetch, isLoading } = useFeatures();

  return (
    <FeaturesContext.Provider
      value={{
        refetch,
        features,
        isLoading,
      }}
    >
      {children}
    </FeaturesContext.Provider>
  );
};
